// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CheckForm from './pages/CheckForm';
import Log from './pages/Log';
import Clients from './pages/Clients';
import Admin from './pages/Admin';
import Profile from './pages/Profile';
import IntervalRequests from './pages/IntervalRequests';
import Schedule from './pages/Schedule';
import CheckOptionsManager from './pages/CheckOptionsManager';
import Searches from './pages/Searches';
import Insights from './pages/Insights';
import './index.css';

function PrivateRoute({ children, requireRole }) {
  const { staff, loading, isAdmin, isSupervisor } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh' }}><div className="spinner" /></div>;
  if (!staff) return <Navigate to="/login" replace />;
  if (requireRole === 'supervisor' && !isSupervisor) return <Navigate to="/" replace />;
  if (requireRole === 'admin' && !isAdmin) return <Navigate to="/" replace />;
  return children;
}

function SessionWarning() {
  const { showSessionWarning, secondsLeft, stayLoggedIn, logout } = useAuth();
  if (!showSessionWarning) return null;
  const mins = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  const timeStr = mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
  return (
    <div className="session-warning">
      <span>Session expires in {timeStr} due to inactivity</span>
      <div style={{ display:'flex', gap:8 }}>
        <button onClick={stayLoggedIn}>Stay signed in</button>
        <button onClick={logout} style={{ background:'rgba(255,255,255,0.2)' }}>Sign out</button>
      </div>
    </div>
  );
}

function AppRoutes() {
  return (
    <>
      <SessionWarning />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/check/:clientId" element={<PrivateRoute><CheckForm /></PrivateRoute>} />
        <Route path="/log" element={<PrivateRoute><Log /></PrivateRoute>} />
        <Route path="/clients" element={<PrivateRoute><Clients /></PrivateRoute>} />
        <Route path="/admin" element={<PrivateRoute requireRole="supervisor"><Admin /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/interval-requests" element={<PrivateRoute><IntervalRequests /></PrivateRoute>} />
        <Route path="/schedule" element={<PrivateRoute><Schedule /></PrivateRoute>} />
        <Route path="/check-options" element={<PrivateRoute requireRole="supervisor"><CheckOptionsManager /></PrivateRoute>} />
        <Route path="/searches" element={<PrivateRoute><Searches /></PrivateRoute>} />
        <Route path="/insights" element={<PrivateRoute requireRole="supervisor"><Insights /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
